import * as yup from 'yup';
import { t } from 'i18next';

const maxSize = 200 * 1024 * 1024;

const toMb = (val) => {
  return (val / (1024 * 1024)).toFixed(1);
};

/**
 * check that second time after the first one
 * @param {*} data
 * @returns
 */
const checkTimes = (__current, data) => {
  // const createError = data.createError;
  const from = data.parent.timefrom;
  const to = data.parent.timetill;
  if (!from || !to) {
    return true;
  }

  // console.log('🚀 ~ checkTimes ~ from > to:', from > to);
  if (from >= to) {
    return false;
  }

  return true;
};

const checkDates = (__current, data) => {
  const from = data.parent.datefrom;
  const to = data.parent.datetill;
  if (!from || !to) {
    return true;
  }
  if (from > to) {
    return false;
  }

  return true;
};

export const validationSchema = () => {
  // console.log('🚀 ~ msg1:', msg1);
  return yup.object({
    file1: yup
      .mixed()
      //.required('Заполните поле')
      .test('empty', t('validation.Заполните поле'), (data) => {
        return data && data.file;
      })
      .test('size', t('validation.Превышен максимальный размер файла ') + toMb(maxSize) + 'Mb', (data) => {
        if (!data) {
          return false;
        }

        const { file } = data;
        if (!file) {
          return false;
        }

        if (file.size && file.size > maxSize) {
          //const dif = file.size - maxSize;
          //const err = 'Превышен максимальный размер файла ' + toMb(maxSize) + 'Мб на ' + toMb(dif) + 'Мб';
          return false;
        }

        return true;
      })
      .test('wh', t('validation.Максимальный допустимое разрешение 1024x430'), (data) => {
        if (!data) {
          return false;
        }
        //console.log('🚀 ~ file1:yup.mixed ~ data:', data);
        const { info } = data; // {duration, width, height}
        if (info) {
          if (info.width > 1024 || info.height > 430) {
            return false;
          }
        }
        return true;
      }),
    duration: yup
      .number()
      //.integer('Только целые числа')
      .positive(t('validation.Только положительные числа'))
      .max(10000, t('validation.Максимум 10000 секунд')),
    //.min(4, 'Минимум 4 символа')
    //.required('Заполните поле')
    datefrom: yup.date().test('dorder-test', t('validation.Дата с не может быть позднее Даты по'), checkDates),
    datetill: yup.date().test('dorder-test', t('validation.Дата по не может быть ранее Даты с'), checkDates),
    timefrom: yup.string().test('order-test', t('validation.Время с не может быть позднее Времени по'), checkTimes),
    timetill: yup.string().test('order-test', t('validation.Время по не может быть ранее Времени с'), checkTimes),
  });
};
